// @module Anchorgroup.CheckoutCustomization.CheckoutCustomization
define('Anchorgroup.CheckoutCustomization.CheckoutCustomization.View'
,	[
	'anchorgroup_checkoutcustomization_checkoutcustomization.tpl'
	
	,	'Backbone'
    ]
, function (
	anchorgroup_checkoutcustomization_checkoutcustomization_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class Anchorgroup.CheckoutCustomization.CheckoutCustomization.View @extends Backbone.View
	return Backbone.View.extend({

		template: anchorgroup_checkoutcustomization_checkoutcustomization_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new CheckoutCustomizationModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Anchorgroup.CheckoutCustomization.CheckoutCustomization.View.Context
	,	getContext: function getContext()
		{
			//@class Anchorgroup.CheckoutCustomization.CheckoutCustomization.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
